var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#3498DB",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3076 36.3814H32.9743M29.6391 33.0481H29.6515M29.6421 39.7148H29.6547",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 20.9292C28.7114 25.0424 35.3813 16.165 39.3279 19.3867C41.5989 21.2405 40.881 25.3334 37.9329 28.0001",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8857 24.7711C42.1967 25.0089 42.4909 25.7908 42.8823 27.9606C43.2349 29.9148 43.3337 32.2599 43.3337 33.2581C43.2978 33.626 43.1379 33.9693 42.8823 34.2493C40.1409 36.9627 34.7005 42.0867 31.9546 44.632C30.877 45.5407 29.2512 45.5603 28.1076 44.7263C25.7658 42.7368 23.5157 40.488 21.3116 38.4572C20.4261 37.38 20.4468 35.8488 21.4117 34.834C24.3165 31.9879 29.5727 27.1164 32.5399 24.4252C32.8374 24.1844 33.2019 24.0338 33.5926 24C34.2583 23.9998 35.4005 24.0844 36.513 24.1453",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.d4d5caa27b367b7230dea0d63e2015f1.svg";
export { ForwardRef as ReactComponent };